export const baseURL = "https://backend.edgent.in/";
export const dataScienceCourseLink = "https://edgentai-public-data.s3.ap-south-1.amazonaws.com/Edgent+Course+DS.pdf";
export const SDECourseLink = "https://edgentai-public-data.s3.ap-south-1.amazonaws.com/Edgent+SDE+Course.pdf";
export const readingMaterial = 'https://edgentai-public-data.s3.ap-south-1.amazonaws.com/python_handbook.md'
